<div class="information-panel" fxLayout="row">
  <spx-icon *ngIf="defaultIcon; else notDefaultIcon" class="spx-icon-size-big" name="error_outline" color="status-warn" [fontSetClass]="'material-icons-outlined'"></spx-icon>
  <ng-template #notDefaultIcon>
    <spx-icon class="spx-icon-size-big" name="campaign" color="status-info" [fontSetClass]="'material-icons-outlined'"></spx-icon>
  </ng-template>
  <div class="content" fxLayout="column">
    <h4>
      <div *ngIf="headerText?.length > 0; else defaultHeader">{{ headerText }}</div>
      <ng-template #defaultHeader>{{ 'WITHDRAW.TITLE' | translate }}</ng-template>
    </h4>
    <div *ngIf="defaultIcon; else notDefaultNotetext" class="spx-body3">{{ noteText | translate }}</div>
    <ng-template #notDefaultNotetext>
      <div [innerHtml]="noteText"></div>
    </ng-template>
  </div>
</div>
